import React from "react";
import { Form } from "antd";
import { useTranslate } from "@refinedev/core";
import { Grid } from "@libertify/ui";
import { PlaybookAddOnCard } from "../PlaybookAddOnCard";
import { PlaybookInput } from "../PlaybookInput";
import { PlaybookFormItem } from "../PlaybookFormItem";
import { normalizeNumericInput } from "../../helpers";
import { useAddonDraft } from "../../context/PlaybookDraftContext";
import { StandoutsFormValues } from "./types";
import { STANDOUTS_DEFAULTS } from "./defaults";
import { CONFIG_ITEM } from "../../data/addons";

// TODO: replace with a real credit estimate once the backend exposes one for
// this add-on. Hardcoded for now (matches the catalog placeholder).
const ESTIMATED_CREDITS = 40;

/**
 * Settings card for the "Standouts" playbook add-on — the frontend name for
 * the backend `Standouts` add-on type (see `StandoutsFormValues`).
 */
export const StandoutsConfigCard: React.FC = () => {
  const t = useTranslate();
  const [form] = Form.useForm<StandoutsFormValues>();
  const { initialValues, onValuesChange } = useAddonDraft(
    CONFIG_ITEM.Standouts,
    STANDOUTS_DEFAULTS
  );

  return (
    <PlaybookAddOnCard
      itemId={CONFIG_ITEM.Standouts}
      title={t("createExperience.addOns.standouts.title")}
      credits={ESTIMATED_CREDITS}
      description={t("createExperience.addOns.standouts.description")}
    >
      <Form<StandoutsFormValues>
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onValuesChange={onValuesChange}
      >
        <Grid columns={2} gap="lg">
          <PlaybookFormItem
            name={["generation_settings", "nb_of_standouts"]}
            labelKey="createExperience.addOns.standouts.numberOfStandouts"
            normalize={normalizeNumericInput}
          >
            <PlaybookInput type="number" min={1} />
          </PlaybookFormItem>
        </Grid>
      </Form>
    </PlaybookAddOnCard>
  );
};

export default StandoutsConfigCard;
